import apiService from "./apiService";

const API_BASE_URL = `${process.env.REACT_APP_API_URL}/api/assistant`;

export const getAssistantService = async (userId) => {
  const response = await apiService
    .post(
      `${API_BASE_URL}/fetch_assistant`,
      {
        userId,
      }
    )
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.error("Error fetching assistant:", error);
      throw error;
    });
  return response;
};
